import { createStore } from "vuex";
import persistedStateVuex from "persisted-state-vuex";

export default createStore({
  state: {
    userLogged: null,
    publicId: null,
  },
  getters: {},
  mutations: {
    getUserLogged(state, value) {
      console.log(value);
      state.userLogged = value.name;
      state.publicId = value.publicId;
      state.schema = value.schema;
    },
  },
  actions: {},
  modules: {},
  plugins: [persistedStateVuex.init],
});
